<script>
  import MarkdownBlock from '/Atoms/MarkdownBlock'

  export let details = ""

  console.log( "<Details>", details || "nothing to do")

</script>

{#if details}
  <div class="details">
    <MarkdownBlock source={details} details />
  </div>
{/if}

<style lang="scss">
  .details {
    margin-bottom: 1em;
  }
</style>